export const colors = {
  alabaster: '#FAFAFA',
  brightTurquoise: '#08D2D4',
  jetStream: '#BFD4D4',
  radicalRed: '#FC2A65',
  scorpion: '#585858',
  white: '#FFFFFF',
  black: '#000000',
};
